// Only the final verifier may receive/store a remembered cookie. Other signup
// requests omit even same-origin cookies, without deleting a browser session.
export function signupTransport(options, $ = window.$) {
    const result = $.Deferred(), controller = new AbortController();
    const headers = {};
    options.beforeSend?.({ setRequestHeader: (name, value) => { headers[name] = value; } });
    if (options.type === 'POST') headers['Content-Type'] = 'application/json';
    let verification = false;
    try {
        const url = new URL(options.url, window.location?.href);
        verification = options.type === 'POST' && url.protocol === 'https:' && !url.username && !url.password && !url.search && !url.hash &&
            ['/api/v4/authentication/signupverify', '/v4/authentication/signupverify'].includes(url.pathname);
    } catch { /* An unrecognised request never enables credentials. */ }
    let timedOut = false;
    const timer = setTimeout(() => { timedOut = true; controller.abort(); }, options.timeout || 30000);
    window.fetch(options.url, { method: options.type, headers, body: options.type === 'POST' ? (options.data || '') : undefined,
        credentials: verification ? 'include' : 'omit', redirect: 'error', cache: 'no-store', referrerPolicy: 'no-referrer', mode: 'cors', signal: controller.signal })
        .then(async response => {
            const xhr = { status: response.status, statusText: '', getResponseHeader: name => response.headers.get(name) };
            if (!response.ok) { result.reject(xhr, 'error'); return; }
            const data = await response.json();
            result.resolve(data, 'success', xhr);
        }).catch(() => { result.reject({ status: 0, statusText: '' }, timedOut ? 'timeout' : 'error'); })
        .finally(() => clearTimeout(timer));
    return Object.assign(result.promise(), { abort() { controller.abort(); } });
}
